
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/tech-stack-audit",
      function () {
        return require("private-next-pages/services/tech-stack-audit.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/tech-stack-audit"])
      });
    }
  